import React, { useContext } from 'react';
import { Button, Loader } from '@fluentui/react-northstar';
import {
  createMicrosoftGraphClient,
  TeamsFx,
  TeamsUserCredential,
} from '@microsoft/teamsfx';
import axios from 'axios';
import { useData } from './useData';
import { Providers } from '@microsoft/mgt-element';
import { AppObject } from '../widgets/AppCard';
import { EntObject } from '../pages/MyHub';
import { ReadinessObject } from '../widgets/ReadinessCard';
import { TeamsFxContext } from '../Context';
import { useGraphWithCredential } from '@microsoft/teamsfx-react';
import { Client } from '@microsoft/microsoft-graph-client';

export const random = (min: number, max: number): number =>
  Math.round(Math.random() * (max - min) + min);

export const loadAppsData = async (
  uid: string,
  allAppsHook: React.Dispatch<React.SetStateAction<AppObject[] | undefined>>,
  entitlementsHook: React.Dispatch<React.SetStateAction<EntObject | undefined>>,
  tenantId: string,
  teamsUserCredential?: TeamsUserCredential
) => {
  try {
    if (uid) {
      const apps = await callFunction(false, 'getAllApps?{0}');
      allAppsHook(apps);

      const entitlesments = await callFunction(
        true,
        'getUserApps?{0}&tenantId=' + tenantId,
        undefined,
        false,
        teamsUserCredential
      );
      entitlementsHook(entitlesments);
    }
  } catch (err) {
    throw err;
  }
};

export const loadReadinessData = async (
  uid: string,
  readinessDataHook: React.Dispatch<
    React.SetStateAction<ReadinessObject[] | undefined>
  >
) => {
  try {
    if (uid) {
      const readiness = await callFunction(false, 'getReadinessContent?{0}');
      readinessDataHook(readiness);
    }
  } catch (err) {
    throw err;
  }
};

export async function callFunction(
  useCredentials?: boolean,
  functionName?: string,
  params?: string,
  isCommerce?: boolean,
  teamsUserCredential?: TeamsUserCredential,
  lang?: string
) {
  try {
    var response;
    //const teamsfx = new TeamsFx();
    const apiConfig =
      process.env.REACT_APP_NGROK === 'true'
        ? process.env.REACT_APP_FUNC_ENDPOINT_NGROK!
        : process.env.REACT_APP_FUNC_ENDPOINT!; //teamsfx.getConfig('apiEndpoint');

    if (useCredentials && teamsUserCredential) {
      //const credential = teamsfx.getCredential();
      const accessToken = (await teamsUserCredential.getToken(''))!.token; //credential.getToken('');

      if (params) {
        response = await axios.post(
          apiConfig +
            '/api/' +
            functionName?.replace(
              '{0}',
              'code=' + process.env.REACT_APP_FUNCS_API_KEY
            ),
          params,
          {
            headers: {
              authorization: 'Bearer ' + accessToken || '',
            },
          }
        );

        return response.data;
      } else {
        response = await axios.get(
          apiConfig +
            '/api/' +
            functionName?.replace(
              '{0}',
              'code=' + process.env.REACT_APP_FUNCS_API_KEY
            ),
          {
            headers: {
              authorization: 'Bearer ' + accessToken || '',
            },
          }
        );

        return response.data;
      }
    } else {
      if (params) {
        response = await axios.post(
          apiConfig +
            '/api/' +
            functionName?.replace(
              '{0}',
              'code=' + process.env.REACT_APP_FUNCS_API_KEY
            ),
          params,
          {
            headers: {},
          }
        );
      } else {
        response = await axios.get(
          apiConfig +
            '/api/' +
            functionName?.replace(
              '{0}',
              'code=' + process.env.REACT_APP_FUNCS_API_KEY
            ),
          {
            headers: {},
          }
        );
        return response.data;
      }
    }
  } catch (err: unknown) {
    if (axios.isAxiosError(err)) {
      let funcErrorMsg = '';

      if (err?.response?.status === 404) {
        funcErrorMsg = `Azure Function not found`;
      } else if (err.message === 'Network Error') {
        funcErrorMsg =
          'Cannot call Azure Function due to network error, please check your network connection status and ';
        if (err.config?.url && err.config.url.indexOf('localhost') >= 0) {
          funcErrorMsg += `make sure to start Azure Function locally first before running this App`;
        } else {
          funcErrorMsg += `make sure to provision and deploy the Azure Function `;
        }
      } else {
        funcErrorMsg = err.message;
        if (err.response?.data?.error) {
          funcErrorMsg += ': ' + err.response.data.error;
        }
      }

      throw new Error(funcErrorMsg);
    }
    throw err;
  }
}

export async function callCommerceFunction(
  useCredentials: boolean,
  functionName: string,
  params?: string
) {
  try {
    var response;
    const apiConfig = process.env.REACT_APP_COMMERCE_FUNCS;
    const apiKey = process.env.REACT_APP_COMMERCE_KEY;

    if (useCredentials) {
      const accessToken = await Providers.globalProvider.getAccessToken();

      if (params) {
        response = await axios.post(
          apiConfig + '/api/' + functionName?.replace('{0}', 'code=' + apiKey),
          params,
          {
            headers: {
              authorization: accessToken,
            },
          }
        );
        return response.data;
      } else {
        response = await axios.get(
          apiConfig + '/api/' + functionName?.replace('{0}', 'code=' + apiKey),
          {
            headers: {
              authorization: accessToken,
            },
          }
        );
        return response.data;
      }
    } else {
      if (params) {
        response = await axios.post(
          apiConfig + '/api/' + functionName?.replace('{0}', 'code=' + apiKey),
          params,
          {}
        );
      } else {
        response = await axios.get(
          apiConfig + '/api/' + functionName?.replace('{0}', 'code=' + apiKey),
          {}
        );
        return response.data;
      }
    }
  } catch (err) {
    if (axios.isAxiosError(err)) {
      let funcErrorMsg = '';

      if (err?.response?.status === 404) {
        funcErrorMsg = `Azure Function not found`;
      } else if (err.message === 'Network Error') {
        funcErrorMsg =
          'Cannot call Azure Function due to network error, please check your network connection status and ';
        if (err.config?.url && err.config.url.indexOf('localhost') >= 0) {
          funcErrorMsg += `make sure to start Azure Function locally first before running this App`;
        } else {
          funcErrorMsg += `make sure to provision and deploy the Azure Function `;
        }
      } else {
        funcErrorMsg = err.message;
        if (err.response?.data?.error) {
          funcErrorMsg += ': ' + err.response.data.error;
        }
      }

      throw new Error(funcErrorMsg);
    }
    throw err;
  }
}

export async function callSpeechFunction(
  functionName: string,
  accessToken: string,
  region: string,
  params?: string
) {
  try {
    var response;
    const apiConfig =
      'https://' +
      region +
      '.tts.speech.' +
      (region.startsWith('china') ? 'azure.cn' : 'microsoft.com') +
      '/';

    if (params) {
      response = await axios.post(apiConfig + functionName, params, {
        headers: {
          authorization: 'Bearer ' + accessToken,
        },
      });
      return response.data;
    } else {
      response = await axios.get(apiConfig + functionName, {
        headers: {
          authorization: 'Bearer ' + accessToken,
        },
      });
      return response.data;
    }
  } catch (err) {
    if (axios.isAxiosError(err)) {
      let funcErrorMsg = '';

      if (err?.response?.status === 404) {
        funcErrorMsg = `Speech Function not found`;
      } else if (err.message === 'Network Error') {
        funcErrorMsg =
          'Cannot call Speech Function due to network error, please check your network connection status and ';
        if (err.config?.url && err.config.url.indexOf('localhost') >= 0) {
          funcErrorMsg += `make sure to start Speech Function locally first before running this App`;
        } else {
          funcErrorMsg += `make sure to provision and deploy the Speech Function `;
        }
      } else {
        funcErrorMsg = err.message;
        if (err.response?.data?.error) {
          funcErrorMsg += ': ' + err.response.data.error;
        }
      }

      throw new Error(funcErrorMsg);
    }
    throw err;
  }
}

export function FunctionsCaller<T>(props: {
  isVisual: boolean;
  functionName?: string;
  useCredentials?: boolean;
  callbackHook?: React.Dispatch<React.SetStateAction<T>>;
}) {
  const { functionName, useCredentials, isVisual, callbackHook } = {
    functionName: '',
    useCredentials: true,
    ...props,
  };

  const { loading, data, error, reload } = useData(callFunction, {
    auto: false,
    useCredentials: useCredentials,
    functionName: functionName,
  });

  if (isVisual) {
    return (
      <div>
        <Button
          primary
          content="Call Azure Function"
          disabled={loading}
          onClick={reload}
        />
        {loading && (
          <pre className="fixed">
            {' '}
            <Loader />{' '}
          </pre>
        )}
        {!loading && !!data && !error && (
          <pre className="fixed">{JSON.stringify(data, null, 2)}</pre>
        )}
        {!loading && !data && !error && <pre className="fixed"></pre>}
        {!loading && !!error && (
          <div className="error fixed">{error.toString()}</div>
        )}
      </div>
    );
  } else {
    if (callbackHook) callbackHook(data);
  }
}

export async function loadContactData(users: string[]) {
  let contacts: any[] = [];
  let proms: Promise<any>[] = [];
  users.forEach((element) => {
    proms.push(
      GetUserDataFromGraph(element).then((value) => contacts.push(value))
    );
  });
  await Promise.allSettled(proms);
  return contacts;
}

export async function GetUserDataFromGraph(uid: string): Promise<any> {
  try {
    const { teamsUserCredential } = useContext(TeamsFxContext);

    await callFunction(
      true,
      'getUserProfile?{0}&uid=' + uid,
      undefined,
      false,
      teamsUserCredential
    ).then((data) => {
      return data;
    });
  } catch (err) {
    throw err;
  }
}

export async function timeout(delay: number) {
  return new Promise((res) => setTimeout(() => {}, delay));
}

export async function SendTeamsNotification(uid: string, subname: string) {
  try {
    const { scope } = {
      scope: ['TeamsActivity.Send', 'TeamsAppInstallation.ReadForUser'],
    };
    const teamsfx = new TeamsFx();
    const graph = createMicrosoftGraphClient(teamsfx, scope);
    await graph
      .api(
        `/users/${uid}/teamwork/installedApps??$expand=teamsApp,teamsAppDefinition&$filter=teamsApp/externalId eq '${process.env.REACT_APP_TEAMS_APPID}'`
      )
      .get()
      .then((value) => {
        const valueObj: any[] = JSON.parse(JSON.stringify(value.value));
        if (valueObj.length > 0) {
          const sendActivityNotification = {
            topic: {
              source: 'entityUrl',
              value: `https://graph.microsoft.com/v1.0/users/${uid}/teamwork/installedApps/${valueObj[0].id}`,
            },
            activityType: 'licenseassigned',
            previewText: {
              content: `You can start enjoying BitFractal`,
            },
            templateParameters: [
              {
                name: 'subname',
                value: subname,
              },
            ],
          };

          graph
            .api('/users/' + uid + '/teamwork/sendActivityNotification')
            .post(sendActivityNotification);
        }
      });
  } catch (err) {
    throw err;
  }
}
